import PropTypes from 'prop-types';
import React from 'react';
import getProgramEpisodeId from '../../../../utils/getProgramEpisodeId';
import { is } from 'immutable';
import CONTENTO_TYPES from '../../../../domain/ContentoTypes';

const SECONDS_WATCHED_BEFORE_SAVING = 30;

export const getContinueWatchingItem = (video, items) => {
    if (video.versions.length === 0) {
        return undefined;
    }
    const videoId = getProgramEpisodeId(video.versions[0].id);

    return items.find((position) => position.videoId === videoId);
};

/**
 * A "render-less" video player plugin that is responisible of
 * saving current position for later use
 */

// Manual polyfill of Math.trunc since next.js doesnt do it
function Mathtrunc(val) {
    return val < 0 ? Math.ceil(val) : Math.floor(val);
}
class ContinueWatching extends React.Component {
    componentDidUpdate(prevProps) {
        // Seek to saved position if the video data has changed
        if (is(this.props.videoData, prevProps.videoData) === false) {
            this._seekToSavedPosition();

            // Block any further actions
            return;
        }

        // Try to update position
        this._updatePosition(Mathtrunc(prevProps.position || 0), Mathtrunc(this.props.position || 0));
    }

    render() {
        return null;
    }

    _updatePosition(prevPosition, nextPosition) {
        // Disabled by settings
        if (!this.props.continueWatchingIsActive) {
            return;
        }

        // Position hasn't changed
        if (prevPosition === nextPosition) {
            return;
        }

        // Position is less than 30s
        if (nextPosition < SECONDS_WATCHED_BEFORE_SAVING) {
            return;
        }

        // The video is of type "clip"
        if (this.props.__typename === CONTENTO_TYPES.CLIP) {
            return;
        }

        // The video is a live broadcast
        if (this.props.streamInfo && this.props.streamInfo.liveNow) {
            return;
        }

        // Save position
        this.props.addContinueWatchingItem(
            this.props.barn,
            this.props.visionId,
            this.props.titleArticleId,
            this.props.__typename,
            nextPosition,
            this.props.duration
        );
    }
}

ContinueWatching.propTypes = {
    position: PropTypes.number,
    continueWatchingItems: PropTypes.object,
    continueWatchingIsActive: PropTypes.bool,
    nextVideoIsBinge: PropTypes.object,
    addContinueWatchingItem: PropTypes.func.isRequired,
    videoPlayer: PropTypes.object,
    duration: PropTypes.number,
    streamInfo: PropTypes.object,
};

export default ContinueWatching;
